export const symbolMap = new Map<string, string>([
    ["±", "\\pm"],
    ["∓", "\\mp"],
    ["×", "\\times"],
    ["÷", "\\div"],
    ["*", ""],
    ["⋆", "\\star"],
    ["∘", "\\circ"],
    ["∙", "\\bullet"],
    ["⋇", "\\odot"],
    ["⋉", "\\ltimes"],
    ["⋊", "\\rtimes"],
    ["⋅", "\\cdot"],
    ["∔", "\\dotplus"],
    ["⋋", "\\leftthreetimes"],
    ["⋌", "\\rightthreetimes"],
    ["⨿", "\\veebar"],
    ["⊗", "\\otimes"],
    ["⊕", "\\oplus"],
    ["⊖", "\\ominus"],
    ["⊘", "\\oslash"],
    ["⊙", "\\odot"],
    ["⊚", "\\circledcirc"],
    ["⊝", "\\circleddash"],
    ["⊛", "\\boxplus"],
    ["◯", "\\bigcirc"],
    ["⊡", "\\boxtimes"],
    ["⊟", "\\boxminus"],
    ["⊞", "\\boxplus"],
    ["⊠", "\\boxtimes"],
    ["⋄", "\\diamond"],
    ["△", "\\triangle"],
    ["▽", "\\triangledown"],
    ["◃", "\\triangleleft"],
    ["▹", "\\triangleright"],
    ["◁", "\\trianglelefteq"],
    ["▷", "\\trianglerighteq"],
    ["⊴", "\\trianglelefteq"],
    ["⊵", "\\trianglerighteq"],
    ["∪", "\\cup"],
    ["∩", "\\cap"],
    ["⊎", "\\uplus"],
    ["⋓", "\\curlywedge"],
    ["⋒", "\\curlyvee"],
    ["≀", "\\wr"],
    ["⧵", "\\setminus"],
    ["∖", "\\setminus"],
    ["⊓", "\\sqcap"],
    ["⊔", "\\sqcup"],
    ["∧", "\\wedge"],
    ["∨", "\\vee"],
    ["⊼", "\\barwedge"],
    ["⊻", "\\veebar"],
    ["⌆", "\\doublebarwedge"],
    ["⋏", "\\bigwedge"],
    ["⋎", "\\bigvee"],
    ["†", "\\dagger"],
    ["‡", "\\ddagger"],
    ["⊺", "\\intercal"],
    ["⋂", "\\bigcap"],
    ["⋃", "\\bigcup"],
    ["⨄", "\\amalg"],
    ["⨆", "\\coprod"],
    ["∏", "\\prod"],
    ["∐", "\\coprod"],
    ["⋀", "\\bigwedge"],
    ["⋁", "\\bigvee"],
    ["⨀", "\\bigodot"],
    ["⨁", "\\bigoplus"],
    ["⨂", "\\bigotimes"],
    ["∑", "\\sum"],
    ["∫", "\\int"],
    ["∮", "\\oint"],
    ["∬", "\\iint"],
    ["∭", "\\iiint"],
    ["⨌", "\\iiiint"]
]);


